import * as THREE from 'three';
import { InsideElementMetadata } from '../Metadata/InsideElementMetadata';
import { InsideContainerGenerator } from './InsideContainerGenerator';

export abstract class BaseInsideElementGenerator {
    protected insideElementMetadata: InsideElementMetadata;
    protected insideContainerGenerator: InsideContainerGenerator;

    constructor(insideContainerGenerator: InsideContainerGenerator, insideElementMetadata: InsideElementMetadata) {
        this.insideContainerGenerator = insideContainerGenerator;
        this.insideElementMetadata = insideElementMetadata;
    }

    public abstract build(): void;

    protected createGameObject(): THREE.Object3D {
        const gameObject = new THREE.Object3D();
        gameObject.name = `${this.insideElementMetadata.Type.toString()}_GEO`;
        return gameObject;
    }
}
